import { Injectable } from '@angular/core';
import { getCurrentUser, signOut, fetchAuthSession, signIn, resetPassword, type ResetPasswordOutput, confirmResetPassword, type ConfirmResetPasswordInput } from 'aws-amplify/auth';
import { BehaviorSubject } from 'rxjs';
import { AuthUser, AuthTokens } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isLoggedInSubject = new BehaviorSubject<boolean>(false);
  isLoggedIn = this.isLoggedInSubject.asObservable();

  constructor() {
    this.checkLoginStatus();
  }

  private async checkLoginStatus() {
    try {
      const user = await getCurrentUser();
      this.isLoggedInSubject.next(!!user);
    } catch {
      this.isLoggedInSubject.next(false);
    }
  }

  async getCurrentUser(): Promise<AuthUser> {
    return await getCurrentUser();
  }
  async getCurrentSession(): Promise<AuthTokens | undefined> {
    const session = await fetchAuthSession();
    return session?.tokens;
  }

  
  async signIn(email: string, password: string): Promise<AuthUser> {
    try {
      await signIn({ username: email, password });
      const user = await getCurrentUser();
      this.isLoggedInSubject.next(true);
      return user;
    } catch (error) {
      console.error('Sign-in error:', error);
      throw error;
    }
  }

  async signOut() {
    await signOut();
    this.isLoggedInSubject.next(false);
  }

  async handleResetPassword(username: string): Promise<void> {
    try {
     await resetPassword({ username });
    } catch (error) {
      console.error('Error in handleResetPassword:', error);
      throw error;
    }
  }

 
  
  async handleConfirmResetPassword(
    username: string,
    confirmationCode: string,
    newPassword: string
  ): Promise<void> {
    try {
      await confirmResetPassword({
        username,
        confirmationCode,
        newPassword
      });
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error;  
    }
  }
}
  


